// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerUIStoreFactory.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require("mobx");
  var constants = require("logic/data/Izenda.ReportsConstants");

  module.exports = function(store) {
    m.extendObservable(store, {
      doesFreeze: false,
      viewerContentTop: 0,
      viewerContentHeight: function() {
        if (!this.doesFreeze) {
          return constants.FITLERS_PANEL_UI.fullHeight;
        }
        const footerElement = $izenda("footer");
        const footerHeight =
          footerElement.length > 0
            ? footerElement[0].getBoundingClientRect().height
            : 0;
        const paddingBottomOfContainer =
          parseInt($izenda(".main-wrapper").css("padding-bottom"), 10) || 0;
        const newHeight =
          $izenda(window).height() -
          this.viewerContentTop -
          footerHeight -
          paddingBottomOfContainer -
          10;

        return newHeight;
      }
    });
  };
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportViewer/Izenda.ReportViewerUIStoreFactory.js